import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetCanalVenta } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCanarVenta } from '../../shared/components';

export interface UpdateCanalVentaPageInterface {}

const returnUrlCanalesVenta = ROUTER_PATHS.administration.canalVentaNav;

const UpdateCanalVentaPage: React.FC<UpdateCanalVentaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_canalventa);

  const { id } = useParams();
  const { data, isLoading } = useGetCanalVenta(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_canal_venta)
    return <Navigate to={returnUrlCanalesVenta} />;

  return (
    <SaveCanarVenta
      titlePage="Editar Canal de Venta"
      editCanalVenta={data.data}
    />
  );
};

export default UpdateCanalVentaPage;
